import classNames from 'classnames';
import React from 'react';
import { TextButton } from '../../common';
import { NAVIGATION } from '../../../config';
import { i18n } from '../../../utils';
import styles from './header-menu.scss';

interface DocumentationLabelProps {
  className?: string;
}

const DocumentationLabel = ({ className }: DocumentationLabelProps) => {
  return (
    <>
      <TextButton
        className={classNames(styles.text)}
        onClick={() =>
          window.open(NAVIGATION.DOCUMENTATION_KNOWLEDGE_BASE_URL, '_blank')
        }
      >
        {i18n.t('documentation.title')}
      </TextButton>
    </>
  );
};

export class HeaderMenu extends React.PureComponent {
  public render() {
    return <DocumentationLabel />;
  }
}
